module.exports = __webpack_public_path__ + "static/img/supplier_walbing_icon.f5e48678.svg";